import React from 'react';

import { Link } from 'gatsby';
import slugify from 'slugify';

const CollectionTaxonomyLink = (props) => (
  <>
    {props.label ? (
      <Link to={`/collections/${props.mediaGroup.toLowerCase()}/${props.taxon}/${slugify(props.label).toLowerCase()}`}>{props.label}</Link>
    ) : null}
  </>
);

export default CollectionTaxonomyLink;